import PropTypes from 'prop-types';

/**
 * Calculate the bill rate for a person based on the client's markup margin and
 * whether it's regular or overtime hours
 *
 * @param {Person's pay rate} payRate
 * @param {Markup margin for regular / overtime hours} markup
 * @param {Flag to determine if payRate is based on regular or overtime hours} isOverTime
 * @returns {number|null} Calculated bill rate or null if inputs are invalid
 */
const CalculateBillRates = (payRate, markup, isOverTime) => {
  // Validate inputs - convert to numbers and check if they are valid
  const numPayRate = typeof payRate === 'number' ? payRate : parseFloat(payRate);
  const numMarkup = typeof markup === 'number' ? markup : parseFloat(markup);

  // Return null if any value is invalid (NaN, null, undefined, or empty string)
  if (
    isNaN(numPayRate) ||
    isNaN(numMarkup) ||
    numPayRate === null ||
    numMarkup === null ||
    numPayRate === undefined ||
    numMarkup === undefined
  ) {
    return null;
  }

  let billRate = 0;
  if (isOverTime) {
    billRate = numPayRate * (1 + numMarkup / 100) * 1.5;
  } else {
    billRate = numPayRate * (1 + numMarkup / 100);
  }

  // Check if the result is valid before formatting
  if (isNaN(billRate) || !isFinite(billRate)) {
    return null;
  }

  return parseFloat(billRate.toFixed(2));
};

CalculateBillRates.propTypes = {
  payRate: PropTypes.number.isRequired,
  markup: PropTypes.number.isRequired,
  isOverTime: PropTypes.number
};

export default CalculateBillRates;
